import { useCallback, useEffect, useMemo, useState } from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/pt-br'
import { toast } from 'sonner'
import { homeNewGraph } from '@/services/dashboard.js'

dayjs.locale('pt-br')
dayjs.extend(utc)

function rangeFor(option) {
  if (option === 1) {
    return {
      from: dayjs.utc().startOf('day').toISOString(),
      to: dayjs.utc().endOf('day').toISOString(),
    }
  }
  if (option === 2) {
    return {
      from: dayjs.utc().subtract(6, 'day').startOf('day').toISOString(),
      to: dayjs.utc().endOf('day').toISOString(),
    }
  }
  if (option === 3) {
    return {
      from: dayjs.utc().subtract(29, 'day').startOf('day').toISOString(),
      to: dayjs.utc().endOf('day').toISOString(),
    }
  }
  return {
    from: dayjs.utc().startOf('month').startOf('day').toISOString(),
    to: dayjs.utc().endOf('day').toISOString(),
  }
}

export function useUsageGraph() {
  const [period, setPeriod] = useState(1)
  const [metric, setMetric] = useState('MESSAGES')
  const [graph, setGraph] = useState([])
  const [loading, setLoading] = useState(true)

  const range = useMemo(() => rangeFor(period), [period])

  const rangeFormat = useMemo(() => {
    const from = dayjs.utc(range.from)
    const to = dayjs.utc(range.to)
    const diffHours = to.diff(from, 'hour')
    const diffDays = to.diff(from, 'day')
    if (diffHours <= 24) return 'HH:mm'
    if (diffDays <= 7) return 'DD MMM'
    return 'DD MMM'
  }, [range])

  useEffect(() => {
    let active = true
    setLoading(true)
    homeNewGraph({ from: range.from, to: range.to, type: metric })
      .then(({ data }) => {
        if (!active) return
        setGraph(
          data.map((item) => ({
            name: (rangeFormat === 'HH:mm'
              ? dayjs(item.date)
              : dayjs.utc(item.date)
            ).format(rangeFormat),
            total: item.value,
          }))
        )
      })
      .catch(() => {
        if (active) toast.error('Falha ao carregar o gráfico.')
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [range.from, range.to, metric, rangeFormat])

  const total = useMemo(
    () => graph.reduce((acc, p) => acc + (p.total ?? 0), 0),
    [graph]
  )

  const onChangePeriod = useCallback((value) => setPeriod(value), [])
  const onChangeMetric = useCallback((value) => setMetric(value), [])

  return {
    graph,
    loading,
    period,
    metric,
    total,
    onChangePeriod,
    onChangeMetric,
  }
}
